module.exports = __webpack_public_path__ + "static/img/img.39b863d5.png";